export enum FractionTsLastCompleteOptionEnum {
  CompleteWithCurrent = 'CompleteWithCurrent',
  CompletePlusCurrent = 'CompletePlusCurrent',
  Complete = 'Complete'
}
